import React from "react";
import "./InfrastructureDevelopment.css";

const InfrastructureDevelopment = () => {
  return (
    <div>
      <h1>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aliquam, in.
      </h1>
    </div>
  );
};

export default InfrastructureDevelopment;
